var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseModel from '../BaseModel';
var PaymentLoyaltyFlowModel = /** @class */ (function (_super) {
    __extends(PaymentLoyaltyFlowModel, _super);
    function PaymentLoyaltyFlowModel(data) {
        var _this = _super.call(this, data) || this;
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.allowGuestDisplay = hydrated.allowGuestDisplay;
        _this.allowOfferSending = hydrated.allowOfferSending;
        _this.allowQsrCustomer = hydrated.allowQsrCustomer;
        _this.allowQsrCustomerSignups = hydrated.allowQsrCustomerSignups;
        _this.alwaysExpandOptions = hydrated.alwaysExpandOptions;
        _this.availableFaces = hydrated.availableFaces;
        _this.checkoutLoyaltyPrompt = hydrated.checkoutLoyaltyPrompt;
        _this.debugCustomers = hydrated.debugCustomers;
        _this.debugOfferSending = hydrated.debugOfferSending;
        _this.defaultServiceTakeout = hydrated.defaultServiceTakeout;
        _this.deliveryMsgText = hydrated.deliveryMsgText;
        _this.disablePickupOnKds = hydrated.disablePickupOnKds;
        _this.enableHandsfree = hydrated.enableHandsfree;
        _this.facialDetectOn = hydrated.facialDetectOn;
        _this.gatherRecipeOptions = hydrated.gatherRecipeOptions;
        _this.guestDisplaySuccessMsg = hydrated.guestDisplaySuccessMsg;
        _this.guestDisplaySuccessTitle = hydrated.guestDisplaySuccessTitle;
        _this.internalGiftcardsCashoutLimit = hydrated.internalGiftcardsCashoutLimit;
        _this.kiosksOn = hydrated.kiosksOn;
        _this.largestSlicePricing = hydrated.largestSlicePricing;
        _this.localMarketingMessage = hydrated.localMarketingMessage;
        _this.localMarketingName = hydrated.localMarketingName;
        _this.localMarketingShortName = hydrated.localMarketingShortName;
        _this.logoutOnTenderingComplete = hydrated.logoutOnTenderingComplete;
        _this.loyaltyScreenDefaultStart = hydrated.loyaltyScreenDefaultStart;
        _this.mobileOrderingHours = hydrated.mobileOrderingHours;
        _this.offersMax = hydrated.offersMax;
        _this.offersStartTime = hydrated.offersStartTime;
        _this.offersStopTime = hydrated.offersStopTime;
        _this.pickupMsgText = hydrated.pickupMsgText;
        _this.pickupPromiseTime = hydrated.pickupPromiseTime;
        _this.poolOutstandingOrders = hydrated.poolOutstandingOrders;
        _this.qsrCustomerPortrait = hydrated.qsrCustomerPortrait;
        _this.quickFinishOrders = hydrated.quickFinishOrders;
        _this.requireManagerOnCancel = hydrated.requireManagerOnCancel;
        _this.retailItems = hydrated.retailItems;
        _this.sendDeliveryMsg = hydrated.sendDeliveryMsg;
        _this.sendPickupMsg = hydrated.sendPickupMsg;
        _this.showCustomerTipHistory = hydrated.showCustomerTipHistory;
        _this.showCustomerVisitHistory = hydrated.showCustomerVisitHistory;
        _this.showFullscreenFlair = hydrated.showFullscreenFlair;
        _this.showLoyalty = hydrated.showLoyalty;
        _this.showPayLater = hydrated.showPayLater;
        _this.showSeparateTipScreen = hydrated.showSeparateTipScreen;
        _this.showStaff = hydrated.showStaff;
        _this.showTipEmojis = hydrated.showTipEmojis;
        _this.smsIntro = hydrated.smsIntro;
        _this.tableServerOn = hydrated.tableServerOn;
        _this.takeoutPayAtKiosk = hydrated.takeoutPayAtKiosk;
        _this.tippingOff = hydrated.tippingOff;
        _this.tipScreenMessage = hydrated.tipScreenMessage;
        _this.useBundles = hydrated.useBundles;
        _this.useCallerid = hydrated.useCallerid;
        _this.useDispatching = hydrated.useDispatching;
        _this.useInternalGiftcards = hydrated.useInternalGiftcards;
        _this.useKdsClaiming = hydrated.useKdsClaiming;
        _this.useLineItemQuantities = hydrated.useLineItemQuantities;
        _this.useMeals = hydrated.useMeals;
        _this.useOptionDefaultsForExceptions = hydrated.useOptionDefaultsForExceptions;
        return _this;
    }
    PaymentLoyaltyFlowModel.prototype.hydrate = function (data) {
        var hydrated = {};
        hydrated.allowGuestDisplay = data.allow_guest_display || null;
        hydrated.allowOfferSending = data.allow_offer_sending || null;
        hydrated.allowQsrCustomer = data.allow_qsr_customer_signups || null;
        hydrated.allowQsrCustomerSignups = data.allow_qsr_customer || null;
        hydrated.alwaysExpandOptions = data.always_expand_options || null;
        hydrated.availableFaces = data.available_faces || null;
        hydrated.checkoutLoyaltyPrompt = data.checkout_loyalty_prompt || null;
        hydrated.debugCustomers = data.debug_customers || null;
        hydrated.debugOfferSending = data.debug_offer_sending || null;
        hydrated.defaultServiceTakeout = data.default_service_takeout || null;
        hydrated.deliveryMsgText = data.delivery_msg_text || null;
        hydrated.disablePickupOnKds = data.disable_pickup_on_kds || null;
        hydrated.enableHandsfree = data.enable_handsfree || null;
        hydrated.facialDetectOn = data.facial_detect_on || null;
        hydrated.gatherRecipeOptions = data.gather_recipe_options || null;
        hydrated.guestDisplaySuccessMsg = data.guest_display_success_msg || null;
        hydrated.guestDisplaySuccessTitle = data.guest_display_success_title || null;
        hydrated.internalGiftcardsCashoutLimit = data.internal_giftcards_cashout_limit || null;
        hydrated.kiosksOn = data.kiosks_on || null;
        hydrated.largestSlicePricing = data.largest_slice_pricing || null;
        hydrated.localMarketingMessage = data.local_marketing_message || null;
        hydrated.localMarketingName = data.local_marketing_name || null;
        hydrated.localMarketingShortName = data.local_marketing_short_name || null;
        hydrated.logoutOnTenderingComplete = data.logout_on_tendering_complete || null;
        hydrated.loyaltyScreenDefaultStart = data.loyalty_screen_default_start || null;
        hydrated.mobileOrderingHours = data.mobile_ordering_hours || null;
        hydrated.offersMax = data.offers_max || null;
        hydrated.offersStartTime = data.offers_start_time || null;
        hydrated.offersStopTime = data.offers_stop_time || null;
        hydrated.pickupMsgText = data.pickup_msg_text || null;
        hydrated.pickupPromiseTime = data.pickup_promise_time || null;
        hydrated.poolOutstandingOrders = data.pool_outstanding_orders || null;
        hydrated.qsrCustomerPortrait = data.qsr_customer_portrait || null;
        hydrated.quickFinishOrders = data.quick_finish_orders || null;
        hydrated.requireManagerOnCancel = data.require_manager_on_cancel || null;
        hydrated.retailItems = data.retail_items || null;
        hydrated.sendDeliveryMsg = data.send_delivery_msg || null;
        hydrated.sendPickupMsg = data.send_pickup_msg || null;
        hydrated.showCustomerTipHistory = data.show_customer_tip_history || null;
        hydrated.showCustomerVisitHistory = data.show_customer_visit_history || null;
        hydrated.showFullscreenFlair = data.show_fullscreen_flair || null;
        hydrated.showLoyalty = data.show_loyalty || null;
        hydrated.showPayLater = data.show_pay_later || null;
        hydrated.showSeparateTipScreen = data.show_separate_tip_screen || null;
        hydrated.showStaff = data.show_staff || null;
        hydrated.showTipEmojis = data.show_tip_emojis || null;
        hydrated.smsIntro = data.sms_intro || null;
        hydrated.tableServerOn = data.table_server_on || null;
        hydrated.takeoutPayAtKiosk = data.takeout_pay_at_kiosk || null;
        hydrated.tippingOff = data.tip_screen_message || null;
        hydrated.tipScreenMessage = data.tipping_off || null;
        hydrated.useBundles = data.use_bundles || null;
        hydrated.useCallerid = data.use_callerid || null;
        hydrated.useDispatching = data.use_dispatching || null;
        hydrated.useInternalGiftcards = data.use_internal_giftcards || null;
        hydrated.useKdsClaiming = data.use_kds_claiming || null;
        hydrated.useLineItemQuantities = data.use_line_item_quantities || null;
        hydrated.useMeals = data.use_meals || null;
        hydrated.useOptionDefaultsForExceptions = data.use_option_defaults_for_exceptions || null;
        return hydrated;
    };
    return PaymentLoyaltyFlowModel;
}(BaseModel));
export default PaymentLoyaltyFlowModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/loyalty/PaymentLoyaltyFlowModel.ts
// module id = null
// module chunks = 